(function () {
  angular.module('binky.core.gainsight', [
    'binky.core.authentication.ready',
    'binky.core.feature.ready',
  ]);
})();
